export const formatDecimal = (num, decimals = 2) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num)
        .toFixed(decimals)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatIso = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("en-PH", {
        year: "numeric",
        month: "short",
        day: "2-digit",
    });
};